export default __webpack_public_path__ + "static/media/021-carbon-monoxide.e1ac667e.png";